export default `
  query getAttachmentDownloadUrl($projectId: String!, $key: String!) {
    getAttachmentDownloadUrl(projectId: $projectId, key: $key) {
      url
      key
    }
  }
`
